import React from 'react'
// ##
import BundleOffersTable from '../../modules/BundleOffer/components/BundleOffersTable'

export default function BundleOfferPage() {
  return <BundleOffersTable />
}
